import { render, staticRenderFns } from "./genai.vue?vue&type=template&id=5fb184f8&scoped=true"
import script from "./genai.vue?vue&type=script&lang=js"
export * from "./genai.vue?vue&type=script&lang=js"
import style0 from "./genai.vue?vue&type=style&index=0&id=5fb184f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb184f8",
  null
  
)

export default component.exports